import React from 'react'

import { IEndClosureAction } from '~/client/graph/types.generated'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { NOOP } from '~/client/src/shared/utils/noop'

import ActionFieldSelector from '../components/ActionFieldSelector'
import { CLOSURE_FIELD_TYPES } from './constants'
import { IActionProps } from './types'

interface IProps extends IActionProps {
  action: IEndClosureAction
}

export default function ClosureEnd(props: IProps) {
  const { action, store, stepId } = props

  return (
    <div className="row">
      <label>{Localization.translator.openResources}</label>
      <ActionFieldSelector
        actionArgumentOptions={store.getFieldArgumentOptions(
          CLOSURE_FIELD_TYPES,
          stepId,
        )}
        onChange={NOOP}
        stepActionFieldIds={action.locationFieldIds || []}
      />
    </div>
  )
}
